import {isNotEmpty} from "./CommonUtil";
import {url} from "./UrlsUtil";

interface ApiResponse{
    error?: string;
    error_message?: string;
    [key: string]: any;
}

interface FetchPostParams{
    action: string;
    data: Record<string, any>;
}

interface FetchUploadParams{
    action: string;
    data: FormData;
}

function validResponseStatus(response: Response): void {
    if (response.status !== 200) {
        throw new Error(`response.status = ${response.status}, response.statusText = ${response.statusText}`);
    }
}

function validError(responseData:ApiResponse | null):ApiResponse | null{
    if (responseData != null) {
        if (isNotEmpty(responseData["error"])) {
            throw new Error(responseData["error"]);
        } else if (isNotEmpty(responseData["error_message"])) {
            throw new Error(responseData["error_message"]);
        }
    }
    return responseData;
}

export async function post<T>({ action, data }: FetchPostParams): Promise<T | undefined | null> {
    const response = await fetch(url(action), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    validResponseStatus(response);
    const responseData: ApiResponse = await response.json();
    return validError(responseData) as T;
}

export async function postUpload<T>({ action, data }: FetchUploadParams): Promise<T | undefined | null> {
    const response = await fetch(url(action), {
        method: "POST",
        body: data,
    });
    validResponseStatus(response);
    const responseData: ApiResponse = await response.json();
    return validError(responseData) as T;
}

export async function fetchPost({ action, data }: FetchPostParams): Promise<ApiResponse | null> {
    const response = await fetch(url(action), {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    validResponseStatus(response);
    const responseData: ApiResponse = await response.json();
    return validError(responseData);
}

export async function fetchUpload({ action, data }: FetchUploadParams): Promise<ApiResponse | null> {
    const response = await fetch(url(action), {
        method: "POST",
        body: data,
    });
    validResponseStatus(response);
    const responseData: ApiResponse = await response.json();
    return validError(responseData);
}

export function createPostJsonInit(data: Record<string, any> | null | undefined): RequestInit {
    return {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data === null || data === undefined ? {} : data),
    };
}